module.exports = __webpack_public_path__ + "icon_prof.png?383d91275dab0f55ea460016d76349fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_prof.png
// module id = 234
// module chunks = 0